/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { InputLabel, OutlinedInput } from "@material-ui/core";
import ListSubheader from "@material-ui/core/ListSubheader";
import TextField from "@material-ui/core/TextField";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { Tooltip } from "@material-ui/core";

import "./buy_style.css";
import "../../App.css";
import BuyModal from "./BuyModal";
import BuySubmit from "./BuySubmit";
import { useGlobalContext } from "../../context/DataContext";
import pkCities from "./pk";
import ErrorMessage from "../Other/ErrorMessage";
import { API_ENDPOINT, getValidApiUrl } from '../../config/config';

const numWords = require("num-words");

const BuyCar = () => {
  // Global Context
  const {
    handleNext,
    setHandleNext,
    handleNext2,
    setHandleNext2,
    divHandle,
    setDivHandle,
  } = useGlobalContext();

  // All States

  const [years, setYears] = React.useState([]);
  const [showBottomText, setShowBottomText] = React.useState(false);

  // Handle Dropdown Selection
  const [selectOption, setSelectOption] = React.useState("");
  const [selectExt, setSelectExt] = React.useState("");
  const [selectTrans, setSelectTrans] = React.useState("");
  const [selectPriorty, setSelectPriorty] = React.useState("");
  const [selectAvailable, setSelectAvailable] = React.useState("");
  const [selectFrom, setSelectFrom] = React.useState("");
  const [selectTo, setSelectTo] = React.useState("");
  const [minBudget, setMinBudget] = React.useState("");
  const [maxBudget, setMaxBudget] = React.useState("");
  const [changeDiv, setChangeDiv] = React.useState(false);
  const [sendBuy, setSendBuy] = React.useState({});

  // Handle the next click function
  const [citiesNames, setCities] = React.useState([]);

  // convert number to words
  const [minBudgetWords, setMinBudgetWords] = React.useState("");
  const [maxAmountWords, setMaxAmountWords] = React.useState("");

  // Available Car and Select Car
  const [availableCar, setAvailableCar] = React.useState([]);
  const [selectCar, setSelectCar] = React.useState({
    make: "make",
    model: "model",
    version: "version",
  });

  //  Handle Upload Pics
  const [selectedFiles, setSelectedFiles] = React.useState();
  const [preview, setPreview] = React.useState([]);

  // Select Multiple Cities Code
  const [personName, setPersonName] = React.useState([]);
  const [extColor, setExtCol] = React.useState([]);

  // send data to submit component
  const [contact, setContact] = React.useState({
    name: "",
    email: "",
    number: "",
    city: "",
    address: "",
    notes: "",
  });

  // End of all states
  /////////////////////////////////////////////////////////

  // Get all years from 1940 to current year
  useEffect(() => {
    let years = function (startYear) {
      var currentYear = new Date().getFullYear(),
        years = [];
      startYear = startYear || 1940;
      while (startYear <= currentYear) {
        years.push(startYear++);
      }

      years.sort(function (a, b) {
        return b - a;
      });
      return years;
    };
    setYears(years(1940));
  }, []);

  // Show element on media query
  useEffect(() => {
    if (window.innerWidth < 768) {
      setShowBottomText(true);
    }
  }, []);

  // Handle Div Changes
  const [error, setError] = useState(false);
  const [errorData, setErrorData] = useState("");


  const handle_next = () => {
    if(selectFrom === "" || selectTo === "" || personName =="" || selectTrans ==="" ){
      setError(true);
      setErrorData("Please fill all the fields");
      return
    }
    setHandleNext(false);
  };

  const handleClick1 = () => {
   
    setHandleNext(true);
  };
  const handleClick2 = () => {
    setHandleNext2(true);
  };

  const handle_next2 = () => {
    if(extColor.length === 0 || minBudget === "" || maxBudget === "" || selectAvailable === "")
    {
      setError(true);
      setErrorData("Please fill all the fields");
      return;
    }
    if (minBudget > maxBudget) {
      setError(true);
      setErrorData("Max budget cannot be less than min budget");
    setMaxBudget(0);
    setMinBudget(minBudget);
    return;
  }
  if (minBudget < 0) {
    alert("Min budget cannot be less than 0");
    setMinBudget(0);
    setMaxBudget(0);
    return;
  }
  if (maxBudget < 0) {
    alert("Max budget cannot be less than 0");
    setMaxBudget(0);
    setMinBudget(0);
    return;
  } else {
      setHandleNext(false);
      setHandleNext2(false);
    }
  };

  // Change Max numbers to words
  const handleChangeMax = (event) => {
    event.target.value.length > 9
      ? alert("Please Enter valid number")
      : setMaxBudget(event.target.value);
    setMaxAmountWords(numWords(event.target.value));
    setTimeout(() => {
      setMaxAmountWords("");
    }, 3000);
  };

  // Change Min numbers to words
  const handleChangeMinBudget = (event) => {
    event.target.value.length > 9
      ? alert("Please Enter valid number")
      : setMinBudget(event.target.value);
    setMinBudgetWords(numWords(event.target.value));
    setTimeout(() => {
      setMinBudgetWords("");
    }, 3000);
  };

  useEffect(() => {
    if (!selectedFiles) {
      setPreview([]);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFiles);
    setPreview([...preview, objectUrl]);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFiles]);

  // End of handle upload pics

  const handleChange = (event) => {
    setSelectOption(event.target.value);
  };
  const handleChange2 = (event) => {
    setSelectExt(event.target.value);
  };
  const handleChange3 = (event) => {
    setSelectTrans(event.target.value);
  };
  const handleChange4 = (event) => {
    setSelectPriorty(event.target.value);
  };
  const handleChange5 = (event) => {
    setSelectAvailable(event.target.value);
  };
  const handleChangeFrom = (event) => {
    setSelectFrom(event.target.value);
  };
  const handleChangeTo = (event) => {
    setSelectTo(event.target.value);
  };

  // Handle Select Car
  const handleChange6 = (value, name) => {
    if (name === "year") {
      setSelectCar({
        ...selectCar,
        [name]: value,
        make: "make",
        model: "model",
        version: "version",
      });
    } else if (name === "make") {
      setSelectCar({
        ...selectCar,
        [name]: value,
        model: "model",
        version: "version",
      });
    } else if (name === "model") {
      setSelectCar({ ...selectCar, [name]: value, version: "version" });
    } else setSelectCar({ ...selectCar, [name]: value });
  };

  // Get Available Cars from API
  const getAvailableCars = async () => {
    try {
      const url = getValidApiUrl('cars/availablecars');
      if (!url) {
        throw new Error('Invalid API URL');
      }
      const res = await axios.get(url);
      return res.data.data;
    } catch (error) {
      console.error('Error fetching available cars:', error);
      setError(true);
      setErrorData('Failed to fetch available cars. Please try again.');
      return [];
    }
  };

  // Updated city list to match structure in SellCar.js
  useEffect(() => {
    const availableCities = [
      { title: "Unregistered", isSpecial: true },
      { title: "Punjab" },
      { title: "Sindh" },
      { title: "KPK" },
      { title: "Balochistan" },
      { title: "Punjab", isHeader: true },
      { title: "Lahore" },
      { title: "Faisalabad" },
      { title: "Rawalpindi" },
      { title: "Multan" },
      { title: "Gujranwala" },
      { title: "Sialkot" },
      { title: "Sheikhupura" },
      { title: "Sargodha" },
      { title: "Sahiwal" },
      { title: "Bahawalpur" },
      { title: "Gujrat" },
      { title: "Jhang" },
      { title: "Kasur" },
      { title: "Okara" },
      { title: "Rahim Yar Khan" },
      { title: "Chiniot" },
      { title: "Dera Ghazi Khan" },
      { title: "Khanewal" },
      { title: "Hafizabad" },
      { title: "Mandi Bahauddin" },
      { title: "Jhelum" },
      { title: "Sindh", isHeader: true },
      { title: "Karachi" },
      { title: "Hyderabad" },
      { title: "Sukkur" },
      { title: "Larkana" },
      { title: "Mirpur Khas" },
      { title: "Nawabshah" },
      { title: "Jacobabad" },
      { title: "Shikarpur" },
      { title: "Dadu" },
      { title: "Thatta" },
      { title: "KPK", isHeader: true },
      { title: "Peshawar" },
      { title: "Mardan" },
      { title: "Mingora" },
      { title: "Kohat" },
      { title: "Dera Ismail Khan" },
      { title: "Abbottabad" },
      { title: "Bannu" },
      { title: "Swabi" },
      { title: "Nowshera" },
      { title: "Charsadda" },
      { title: "Balochistan", isHeader: true },
      { title: "Quetta" },
      { title: "Turbat" },
      { title: "Khuzdar" },
      { title: "Gwadar" },
      { title: "Hub" },
      { title: "Chaman" },
      { title: "Pishin" },
      { title: "Zhob" },
      { title: "Loralai" },
      { title: "Sibi" },
      { title: "Gilgit Baltistan", isHeader: true },
      { title: "Gilgit" },
      { title: "Skardu" },
      { title: "Hunza" },
      { title: "Ghizer" },
      { title: "Azad Kashmir", isHeader: true },
      { title: "Muzaffarabad" },
      { title: "Mirpur" },
      { title: "Kotli" },
      { title: "Rawalakot" },
      { title: "Bagh" },
      { title: "Federal Territory", isHeader: true },
      { title: "Islamabad" }
    ];

    setCities(availableCities);

    getAvailableCars().then((res) => {
      setAvailableCar(res);
    });
  }, []);

  // Function to convert title array to array of strings
  const getCityTitles = (cities) => {
    return cities.map(city => typeof city === 'string' ? city : city.title);
  };

  // Change handler for cities
  const changeFilterCity = (event, newValue) => {
    // Convert the city objects to strings (just the titles)
    const selectedCities = Array.isArray(newValue) 
      ? newValue.map(city => typeof city === 'string' ? city : city.title)
      : [];
    
    // Check if "Unregistered" is being selected or deselected
    if (selectedCities.includes("Unregistered")) {
      // If Unregistered is selected, only allow Unregistered
      setPersonName(["Unregistered"]);
    } else if (personName.includes("Unregistered")) {
      // If coming from Unregistered to other cities, set only the new selection
      setPersonName(selectedCities.filter(city => city !== "Unregistered"));
    } else {
      // Normal multi-selection behavior
      setPersonName(selectedCities);
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  // Updated color list to match SellCar.js with more colors, sorted alphabetically
  const availableColors = [
    { title: "Red" },
    { title: "Green" },
    { title: "Yellow" },
    { title: "Blue" },
    { title: "Black" },
    { title: "White" },
    { title: "Silver" },
    { title: "Gray" },
    { title: "Brown" },
    { title: "Orange" },
    { title: "Pink" },
    { title: "Purple" },
    { title: "Gold" },
    { title: "Beige" },
    { title: "Maroon" },
    { title: "Mint" },
    { title: "Navy" },
    { title: "Lavender" },
    { title: "Turquoise" },
    { title: "Copper" },
    { title: "Champagne" },
    { title: "Indigo" },
    { title: "Tan" },
    { title: "Burgundy" },
    { title: "Plum" },
    { title: "Khaki" },
    { title: "Aquamarine" },
    { title: "Lime" },
    { title: "Coral" },
    { title: "Teal" },
    { title: "Lilac" },
    { title: "Fuchsia" },
    { title: "Wine" },
    { title: "Army" },
    { title: "Lemon" },
    { title: "Olive" },
    { title: "Apricot" },
    { title: "Mauve" },
    { title: "Taupe" },
    { title: "Crimson" },
    { title: "Ivory" },
    { title: "Charcoal" },
    { title: "Cyan" },
    { title: "Azure" }
  ].sort((a, b) => a.title.localeCompare(b.title));

  const handleChangeCities = (event) => {
    const {
      target: { value },
    } = event;
    
    // Convert the value to array if it's a string
    const selectedValues = typeof value === "string" ? value.split(",") : value;
    
    // Check if "Unregistered" is being selected or deselected
    if (selectedValues.includes("Unregistered")) {
      // If Unregistered is selected, only allow Unregistered
      setPersonName(["Unregistered"]);
    } else if (personName.includes("Unregistered")) {
      // If coming from Unregistered to other cities, set only the new selection
      setPersonName(selectedValues.filter(city => city !== "Unregistered"));
    } else {
      // Normal multi-selection behavior
      setPersonName(selectedValues);
    }
  };

  // Filter cities based on search
  const [citySearchTerm, setCitySearchTerm] = React.useState("");
  const filteredCities = React.useMemo(() => {
    return citiesNames.filter(city => {
      if (typeof city === 'object' && city.isHeader) return true;
      if (typeof city === 'string') {
        return city.toLowerCase().includes(citySearchTerm.toLowerCase());
      }
      return false;
    });
  }, [citiesNames, citySearchTerm]);

  // New function to handle color selection with Autocomplete
  const changeFilter = (event, newValue) => {
    // If newValue is null, set to empty array
    if (!newValue) {
      setExtCol([]);
      return;
    }
    
    // Handle the color selection properly
    setExtCol(newValue);
  };

  const handleContact = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setContact({ ...contact, [name]: value });
  };

  const handleBuyDivChange = () => {
    if (
      contact.name === "" ||
      contact.number === "" ||
      contact.address === "" ||
      contact.city === ""
    ) {
      setError(true);
      setErrorData("Please fill all the fields");
      return;
    }
    setDivHandle(true);
    
    // Convert color objects to strings if they are objects
    const processedExtColors = extColor.map(color => 
      typeof color === 'object' && color.title ? color.title : color
    );
    
    setSendBuy({
      selectFrom,
      selectTo,
      personName,
      extColor: processedExtColors,
      selectTrans,
      selectAvailable,
      minBudget,
      maxBudget,
      selectCar,
      contact,
    });
  };

  return (
    <>
      <ErrorMessage open={error} setOpen={setError} data={errorData} />
      {/* Start of Buy Car  */}
      <div className="nav-wrapper sell_your_car">
        <div className="image-wrapper">
          <Link to="/">
            <img src="assets/images/logo.png" width="222px" alt="" />
          </Link>
        </div>
        <div className="text-wrapper">
          <h1
            style={{
              fontSize: "24px",
              paddingLeft: "16rem",
              paddingTop: "20px",
              fontWeight: 700,
            }}
          >
            Buy your car in three easy steps
          </h1>
        </div>
      </div>
      <div className="progress-steps-container">
        <div className="progress-steps">
          <div className={`progress-step ${handleNext ? 'active' : ''}`} onClick={handleClick1} style={{
            cursor: "pointer",
            padding: "10px 0",
            transition: "all 0.3s ease",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            position: "relative"
          }}>
            <div className="step-number" style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: handleNext ? "#ff4605" : "#e0e0e0",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              marginBottom: "8px",
              transition: "all 0.3s ease"
            }}>1</div>
            <div className="step-text" style={{
              fontWeight: handleNext ? "bold" : "normal"
            }}>Car Information</div>
          </div>
          <div className={`progress-step ${!handleNext && handleNext2 ? 'active' : ''}`} onClick={handleClick2} style={{
            cursor: "pointer",
            padding: "10px 0",
            transition: "all 0.3s ease",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            position: "relative"
          }}>
            <div className="step-number" style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: !handleNext && handleNext2 ? "#ff4605" : "#e0e0e0",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              marginBottom: "8px",
              transition: "all 0.3s ease"
            }}>2</div>
            <div className="step-text" style={{
              fontWeight: !handleNext && handleNext2 ? "bold" : "normal"
            }}>Set Priority & Budget</div>
          </div>
          <div className={`progress-step ${!handleNext2 ? 'active' : ''}`} style={{
            padding: "10px 0",
            transition: "all 0.3s ease",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            position: "relative"
          }}>
            <div className="step-number" style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              backgroundColor: !handleNext2 ? "#ff4605" : "#e0e0e0",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              marginBottom: "8px",
              transition: "all 0.3s ease"
            }}>3</div>
            <div className="step-text" style={{
              fontWeight: !handleNext2 ? "bold" : "normal"
            }}>Contact Information</div>
          </div>
        </div>
      </div>
      <div
        className="position-relative"
        style={{
          minHeight: "88vh",
        }}
      >
        {divHandle === false ? (
          <div className="container-fluid" id="sellyourcar">
            <div className="row justify-content-center mt-0">
              <div className="col-11 col-sm-9 col-md-7 col-lg-12 text-center p-0 mt-2 mb-2">
                <div className="px-0 pt-1 pb-0 mt-1">
                  {/* <!-- <h2><strong>Sign Up Your User Account</strong></h2>
                    <p>Fill all form field to go to next step</p> --> */}
                  <div className="row buy_a_car m-0">
                    <div className="col-md-12 col-12 mx-0 p-0">
                      <form id="msform">
                        {/* <!-- fieldsets --> */}
                        {handleNext ? (
                          <fieldset id="fieldset-1">
                            <div className="form-card container">
                              <p>STEP 1</p>
                              <h3 className="fs-title">
                                Enter your car information
                              </h3>
                              <div
                                className="row d-flex sell_a_car_row"
                                style={{ marginBottom: "60px", flexWrap: "wrap" }}
                              >
                                <div
                                  className="col-lg-6 col-sm-12 make_button"
                                  style={{ width: "100%", maxWidth: "620px", marginBottom: "20px" }}
                                >
                                  <div className="d-flex set_availability" style={{flexDirection: "column"}}>
                                    <div
                                      className="flex-1"
                                      style={{ position: "relative", width: "100%" }}
                                    >
                                      <div
                                        className=""
                                        style={{ marginTop: "10px" }}
                                      >
                                        <label className="pay">
                                          Select Year Range
                                          <span className="text-warning">
                                            *
                                          </span>
                                        </label>
                                      </div>
                                      <p
                                        className="text-para-22"
                                        style={
                                          preview.length > 0
                                            ? { top: "112px" }
                                            : null
                                        }
                                      >
                                        From
                                      </p>
                                      <div className="">
                                        <div className="d-flex years_select_div">
                                          <FormControl
                                            sx={{ m: 1, minWidth: 120 }}
                                          >
                                            <Select
                                              value={selectFrom}
                                              onChange={handleChangeFrom}
                                              displayEmpty
                                              inputProps={{
                                                "aria-label": "Without label",
                                              }}
                                              className="list-dt-1"
                                              id="from"
                                              name="expmonth"
                                              required={true}
                                            >
                                              <MenuItem value="">
                                                Select Year
                                              </MenuItem>
                                              {years.map((item, index) => (
                                                <MenuItem key={`year-${item}`} value={item}>
                                                  {item}
                                                </MenuItem>
                                              ))}
                                            </Select>
                                          </FormControl>
                                          <div style={{ position: "relative" }}>
                                            <p className="text-para-33">To</p>
                                            <FormControl
                                              sx={{ m: 1, minWidth: 120 }}
                                            >
                                              <Select
                                                value={selectTo}
                                                onChange={handleChangeTo}
                                                displayEmpty
                                                inputProps={{
                                                  "aria-label": "Without label",
                                                }}
                                                className="list-dt-1"
                                                id="to"
                                                name="expmonth"
                                                required={true}
                                                disabled={
                                                  selectFrom === ""
                                                    ? true
                                                    : false
                                                }
                                              >
                                                <MenuItem value="">
                                                  Select Year
                                                </MenuItem>
                                                {years.map((item, index) => {
                                                  if (item >= selectFrom) {
                                                    return (
                                                      <MenuItem value={item}>
                                                        {item}
                                                      </MenuItem>
                                                    );
                                                  }
                                                })}
                                              </Select>
                                            </FormControl>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-lg-6 col-sm-12 make_button"
                                  style={{ width: "100%", maxWidth: "620px", marginTop: "10px" }}
                                >
                                  <div className="">
                                    <label className="pay">
                                      Make
                                      <span className="text-warning">*</span>
                                    </label>
                                    <BuyModal
                                      yearFrom={selectFrom}
                                      yearTo={selectTo}
                                      fun={handleChange6}
                                      value={availableCar}
                                      selectCar={selectCar}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex buy_a_car_bottom " style={{flexWrap: "wrap", width: "100%"}}>
                                <div className="col-lg-6 col-sm-12 p-0 " style={{width: "100%", marginBottom: "20px"}}>
                                  <div className="position-relative">
                                    <label className="pay">
                                      You can select multiple
                                      <span className="text-warning">*</span>
                                    </label>
                                  </div>
                                  <Tooltip
                                    title="Select registration cities"
                                    placement="top-start"
                                  >
                                    <Autocomplete
                                      multiple
                                      id="city-selection"
                                      options={citiesNames}
                                      value={personName.map(name => {
                                        // Find the city object or create a string object
                                        const cityObj = citiesNames.find(city => 
                                          typeof city === 'object' && city.title === name);
                                        return cityObj || { title: name };
                                      })}
                                      getOptionDisabled={(option) => {
                                        return (option.isHeader === true) || 
                                              (personName.includes("Unregistered") && option.title !== "Unregistered");
                                      }}
                                      onChange={changeFilterCity}
                                      getOptionLabel={(option) => {
                                        if (typeof option === 'string') return option;
                                        return option.title || '';
                                      }}
                                      renderOption={(option) => (
                                        <div style={{ 
                                          padding: option.isHeader ? "12px 16px 8px" : "8px 16px 8px 32px",
                                          backgroundColor: option.isHeader ? "#f5f5f5" : "transparent",
                                          fontWeight: option.isHeader || option.isSpecial ? 600 : 400,
                                          color: option.isHeader ? "#666" : "#333",
                                          pointerEvents: option.isHeader ? "none" : "auto",
                                          borderBottom: option.isHeader ? "1px solid #ddd" : "none"
                                        }}>
                                          {option.title}
                                        </div>
                                      )}
                                      style={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          label="Select cities"
                                          placeholder="Type to search"
                                        />
                                      )}
                                      groupBy={(option) => {
                                        if (option.isHeader || option.isSpecial) return "";
                                        // Find the previous header
                                        const index = citiesNames.findIndex(city => 
                                          typeof city === 'object' && city.title === option.title);
                                        for (let i = index; i >= 0; i--) {
                                          if (citiesNames[i].isHeader) {
                                            return citiesNames[i].title;
                                          }
                                        }
                                        return "";
                                      }}
                                    />
                                  </Tooltip>
                                </div>

                                <div
                                  className="col-lg-6 col-sm-12 p-0"
                                  style={{ width: "100%", marginRight: "0px" }}
                                >
                                  <div className="">
                                    <label className="pay">
                                      Transmission
                                      <span className="text-warning">*</span>
                                    </label>
                                  </div>
                                  <Tooltip
                                    title="Select your preferred transmission type"
                                    placement="top-start"
                                  >
                                    <FormControl sx={{ m: 1, minWidth: 300 }}>
                                    <Select
                                      value={selectTrans}
                                      onChange={handleChange3}
                                      displayEmpty
                                      className="list-dt-4"
                                        style={{
                                          fontSize: "14px"
                                        }}
                                    >
                                      <MenuItem value="">
                                        Select Transmission
                                      </MenuItem>
                                      <MenuItem value="automatic">
                                        Automatic
                                      </MenuItem>
                                      <MenuItem value={"manual"}>
                                        Manual
                                      </MenuItem>
                                      <MenuItem value={"any"}>Any</MenuItem>
                                    </Select>
                                  </FormControl>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>


                          </fieldset>
                        ) : null}

                        {handleNext2 ? (
                          <fieldset id="fieldset-2">
                            <div className="form-card container">
                              {/* <span className="active prog-btn" id="account" onClick={handleClick1}>
                      <a className="achor-wrap" href="#fieldset-1"
                        ><strong className="strong-wrapp">Arrow</strong></a>
                    </span> */}
                              <p>STEP 2</p>
                              <h2 className="fs-title">
                                Select color and budget
                              </h2>

                              <div className="row p-0 m-0">
                                <div className="col-lg-6 col-sm-12 p-0">
                                  <div className="">
                                    <label className="pay">
                                      Multiple Exterior Color
                                      <span className="text-warning">*</span>
                                    </label>
                                  </div>
                                  <Tooltip
                                    title="Select your preferred vehicle exterior colors"
                                    placement="top-start"
                                  >
                                    <Autocomplete
                                      multiple
                                      value={extColor}
                                      onChange={changeFilter}
                                      options={availableColors}
                                      getOptionLabel={(option) => {
                                        if (typeof option === "string") {
                                          return option;
                                        }
                                        return option.title || "";
                                      }}
                                      renderOption={(option) => (
                                        <div style={{ 
                                          padding: "8px 16px",
                                          display: "flex",
                                          alignItems: "center"
                                        }}>
                                          <div style={{
                                            width: "20px",
                                            height: "20px",
                                            borderRadius: "50%",
                                            backgroundColor: option.title.toLowerCase(),
                                            marginRight: "10px",
                                            border: "1px solid #ddd"
                                          }} />
                                          {option.title}
                                        </div>
                                      )}
                                      style={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Colors"
                                          variant="outlined"
                                        />
                                      )}
                                    />
                                  </Tooltip>
                                </div>
                                <div className="col-lg-6 p-0">
                                  <div className="flex-2">
                                    <div className="">
                                      <label className="pay">
                                        Budget
                                        <span className="text-warning">*</span>
                                      </label>
                                    </div>
                                    <div className="d-flex">
                                      <div className="position-relative">
                                        <div className="form-group d-flex">
                                          <p className="min-label">MIN</p>
                                          <input
                                            type="text"
                                            className="input-wrapp"
                                            id="minBudget"
                                            placeholder="Rs"
                                            value={minBudget}
                                            onChange={handleChangeMinBudget}
                                            style={{
                                              border: 0,
                                              padding: "10px 10px 10px 20px",
                                              background: "#f5f6f7 0% 0% no-repeat padding-box",
                                              marginRight: "5px",
                                              height: "40px",
                                              fontSize: "16px",
                                            }}
                                          />

                                          {minBudgetWords.length > 0 ? (
                                            <div className="guess_number guess_min">
                                              <span>{minBudgetWords}</span>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                      <div className="position-relative">
                                        <div className="form-group d-flex">
                                          <p className="max-label">MAX</p>
                                          <input
                                            type="text"
                                            className="input-wrapp-2"
                                            id="maxBudget"
                                            placeholder="Rs"
                                            value={maxBudget}
                                            onChange={handleChangeMax}
                                            style={{
                                              border: 0,
                                              padding: "10px 10px 10px 20px",
                                              background: "#f5f6f7 0% 0% no-repeat padding-box",
                                              marginRight: "5px",
                                              height: "40px",
                                              fontSize: "16px",
                                            }}
                                          />
                                          {maxAmountWords.length > 0 ? (
                                            <div className="guess_number guess_min">
                                              <span>{maxAmountWords}</span>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="wrap-pad m-0 ">
                                <div className="wrapper">
                                  <div className="">
                                    <label className="pay ">
                                      Urgency
                                      <span className="text-warning">*</span>
                                    </label>
                                  </div>
                                  <Tooltip
                                    title="Select your urgency level for buying a car"
                                    placement="top-start"
                                  >
                                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                                    <Select
                                      value={selectAvailable}
                                      onChange={handleChange5}
                                      displayEmpty
                                      className="list-dt-5"
                                      style={{
                                        fontWeight: "400",
                                          fontSize: "14px",
                                          minWidth: "300px"
                                      }}
                                    >
                                      <MenuItem
                                        value=""
                                          style={{ fontSize: "14px" }}
                                      >
                                        Please Select One Option                                        
                                      </MenuItem>
                                      <MenuItem
                                        value="High: Need a car on urgent basis"
                                          style={{ fontSize: "14px" }}
                                      >
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                        <span
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                                marginRight: "8px"
                                          }}
                                        >
                                          High
                                        </span>
                                            <span>Need a car on urgent basis</span>
                                          </div>
                                      </MenuItem>
                                      <MenuItem
                                          value={"Medium : Need a car within 15 days"}
                                          style={{ fontSize: "14px" }}
                                      >
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                        <span
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                                marginRight: "8px"
                                              }}
                                            >
                                              Medium
                                            </span>
                                            <span>Need a car within 15 days</span>
                                          </div>
                                      </MenuItem>
                                      <MenuItem
                                          value={"Low : Need a car in best condition possible"}
                                          style={{ fontSize: "14px" }}
                                      >
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                        <span
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: "500",
                                                marginRight: "8px"
                                              }}
                                            >
                                              Low
                                            </span>
                                            <span>Need a car in best condition possible</span>
                                          </div>
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>


                          </fieldset>
                        ) : (
                          <fieldset id="fieldset-3">
                            <div className="form-card container">
                              <div className="text-wrap">
                                <p>STEP 3</p>
                                <h6 className="fs-title">
                                  Contact information
                                </h6>
                              </div>

                              <div
                                className="col-lg-12 col-sm-12 d-flex contact_divs_column p-0"
                                style={{ marginBottom: "50px", padding: "0px" }}
                              >
                                <div className="wrap-1">
                                  <label
                                    className="pay"
                                    style={{ display: "block" }}
                                  >
                                    Name <span className="text-warning">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Type Full Name"
                                    required={true}
                                    className="input-11"
                                    id="name"
                                    name="name"
                                    value={contact.name}
                                    onChange={handleContact}
                                    style={{
                                      border: 0,
                                      padding: "10px 15px",
                                      background: "#f5f6f7 0% 0% no-repeat padding-box",
                                      height: "40px",
                                      fontSize: "14px",
                                      width: "100%",
                                      borderRadius: "4px"
                                    }}
                                  />
                                </div>
                                <div className="wrap-2">
                                  <label
                                    className="pay"
                                    style={{ display: "block" }}
                                  >
                                    Email{" "}
                                    <span
                                      style={{ color: "#6c757d", fontWeight: "normal", fontSize: "14px" }}
                                    >
                                      (optional)
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Type Your Email"
                                    className="input-11"
                                    id="email"
                                    name="email"
                                    value={contact.email}
                                    onChange={handleContact}
                                    style={{
                                      border: 0,
                                      padding: "10px 15px",
                                      background: "#f5f6f7 0% 0% no-repeat padding-box",
                                      height: "40px",
                                      fontSize: "14px",
                                      width: "100%",
                                      borderRadius: "4px"
                                    }}
                                  />
                                </div>
                                <div className="wrap-3">
                                  <label
                                    className="pay"
                                    style={{ display: "block" }}
                                  >
                                    Contact Number
                                    <span className="text-warning">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Type Your Contact Number"
                                    required={true}
                                    className="input-11"
                                    id="number"
                                    name="number"
                                    value={contact.number}
                                    onChange={handleContact}
                                    style={{
                                      border: 0,
                                      padding: "10px 15px",
                                      background: "#f5f6f7 0% 0% no-repeat padding-box",
                                      height: "40px",
                                      fontSize: "14px",
                                      width: "100%",
                                      borderRadius: "4px"
                                    }}
                                  />
                                </div>
                              </div>

                              <div
                                className="col-12 d-flex address_div_mobile"
                                style={{ marginBottom: "20px" }}
                              >
                                <div className="wrap-3">
                                  <label
                                    className="pay"
                                    style={{ display: "block" }}
                                  >
                                    City <span className="text-warning">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Select City"
                                    required={true}
                                    className="input-11"
                                    id="city"
                                    name="city"
                                    value={contact.city}
                                    onChange={handleContact}
                                    style={{
                                      border: 0,
                                      padding: "10px 15px",
                                      background: "#f5f6f7 0% 0% no-repeat padding-box",
                                      height: "40px",
                                      fontSize: "14px",
                                      width: "100%",
                                      borderRadius: "4px"
                                    }}
                                  />
                                </div>
                                <div className="wrap-3">
                                  <label
                                    className="pay"
                                    style={{ display: "block" }}
                                  >
                                    Address{" "}
                                    <span className="text-warning">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Type Your Address"
                                    required={true}
                                    className="input-22"
                                    id="address"
                                    name="address"
                                    value={contact.address}
                                    onChange={handleContact}
                                    style={{
                                      border: 0,
                                      padding: "10px 15px",
                                      background: "#f5f6f7 0% 0% no-repeat padding-box",
                                      height: "40px",
                                      fontSize: "14px",
                                      width: "100%",
                                      borderRadius: "4px"
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                className="wrap-3 buy_notes_area"
                                style={{ marginTop: "50px" }}
                              >
                                <label
                                  className="pay"
                                  style={{ display: "block" }}
                                >
                                  Notes <span style={{ color: "#6c757d", fontWeight: "normal", fontSize: "14px" }}>(Optional)</span>
                                </label>
                                <textarea
                                  name="notes"
                                  value={contact.notes}
                                  rows="4"
                                  cols="50"
                                  placeholder="Add Notes"
                                  id="notes"
                                  required={true}
                                  onChange={handleContact}
                                  style={{
                                    border: 0,
                                    padding: "10px 15px",
                                    background: "#f5f6f7 0% 0% no-repeat padding-box",
                                    fontSize: "14px",
                                    width: "100%",
                                    borderRadius: "4px",
                                    resize: "vertical"
                                  }}
                                ></textarea>
                              </div>
                            </div>
                            {/* <!-- <input type="submit" id="myElement" className="next action-button review-1 submit"
                                        value="Save & review" /> --> */}


                          </fieldset>
                        )}
                      </form>
                      
                      {/* Buttons outside msform */}
                      <div className="outside-msform-buttons">
                        {handleNext ? (
                            <div style={{
                              display: 'flex',
                              justifyContent: 'center',
                            alignItems: 'center',
                              marginTop: '40px',
                              marginBottom: '40px',
                              width: '100%',
                            position: 'relative',
                            zIndex: 100
                          }}>
                            <input
                              type="button"
                              name="next"
                              className="next action-button outside-msform"
                              value="Save & Continue"
                              onClick={handle_next}
                              style={{
                                width: '100%',
                                maxWidth: '200px',
                                background: '#ff4605',
                                fontWeight: 'bold',
                                color: 'white',
                                border: '0 none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                padding: '15px 10px',
                                margin: '0 auto',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                                textAlign: 'center',
                                transition: 'all 0.2s',
                                position: 'static',
                                float: 'none',
                                fontSize: '14px',
                                display: 'block',
                                right: 'auto',
                                bottom: 'auto'
                              }}
                            />
                          </div>
                        ) : null}
                        
                        {!handleNext && handleNext2 ? (
                          <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: '40px',
                            marginBottom: '40px',
                            width: '100%',
                            position: 'relative',
                            zIndex: 100
                          }}>
                            <input
                              type="button"
                              name="next"
                              className="next action-button outside-msform"
                              value="Save & Continue"
                              onClick={handle_next2}
                              style={{
                                width: '100%',
                                maxWidth: '200px',
                                background: '#ff4605',
                                fontWeight: 'bold',
                                color: 'white',
                                border: '0 none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                padding: '15px 10px',
                                margin: '0 auto',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                                textAlign: 'center',
                                transition: 'all 0.2s',
                                position: 'static',
                                float: 'none',
                                fontSize: '14px',
                                display: 'block',
                                right: 'auto',
                                bottom: 'auto'
                              }}
                            />
                          </div>
                        ) : null}
                        
                        {!handleNext && !handleNext2 ? (
                          <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: '40px',
                            marginBottom: '40px',
                            width: '100%',
                            position: 'relative',
                            zIndex: 100
                            }}>
                            <button
                              className="next action-button outside-msform"
                              type="button"
                              onClick={handleBuyDivChange}
                                style={{
                                width: '100%',
                                maxWidth: '200px',
                                  background: '#ff4605',
                                  fontWeight: 'bold',
                                  color: 'white',
                                  border: '0 none',
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                padding: '15px 10px',
                                margin: '0 auto',
                                  textTransform: 'uppercase',
                                  letterSpacing: '1px',
                                  textAlign: 'center',
                                transition: 'all 0.2s',
                                position: 'static',
                                float: 'none',
                                fontSize: '14px',
                                display: 'block',
                                right: 'auto',
                                bottom: 'auto'
                                }}
                              >
                                Save & Review
                            </button>
                            </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <BuySubmit data={sendBuy} />
        )}
      </div>
    </>
  );
};

export default BuyCar;
